/**
 * Generic route existence check via meta.
 *
 * Route example:
 * {
 *   path: ':walletUuid',
 *   name: 'Wallet',
 *   meta: {
 *     validateRoute: (to) => !!useWallets().getWalletByUuid(to.params.walletUuid),
 *     fallbackRoute: { name: 'Wallets' },
 *   },
 * }
 */

export const validateRouteMiddleware = async (to) => {
  for (const record of to.matched) {
    const { validateRoute, fallbackRoute } = record.meta

    if (!validateRoute) {
      continue
    }

    const isValid = await validateRoute(to)

    if (!isValid) {
      return {
        ...(fallbackRoute || { path: '/' }),
        replace: true,
      }
    }
  }
}
